import { render, staticRenderFns } from "./ListRequestStockPei.vue?vue&type=template&id=58be8ab6&"
import script from "./ListRequestStockPei.vue?vue&type=script&lang=js&"
export * from "./ListRequestStockPei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports